export interface UserReportRequest {
    description: string | null
    reportType: ReportType
    reportedChatMessageUuid: string | null
    reportedUserUuid?: string | null
    reportedKnowUuid?: string | null
    isAnonymous: boolean
    userReason: string
}

export enum ReportType {
    user = 'USER',
    know = 'KNOW',
    question = 'QUESTION',
    answer = 'ANSWER',
    comment = 'COMMENT',
    chatMessage = 'CHAT_MESSAGE',
    answerComment = 'ANSWER_COMMENT',
}

export interface ReportReason {
    canBeReportedAnonymously: boolean
    name: string
}
